module.exports = __webpack_public_path__ + "static/images/printer.83cd85dfac172cbb4aa477c6bc404f17.svg";